const MenuItemStore = {
  data: {
    items: [
      {
        action: 'dashboard',
        title: 'Dashboard',
        link: '/dashboard'
      },
      {
        action: 'mdi mdi-file-document-box-multiple-outline',
        title: 'Documents',
        link: '/docs'
      },
      {
        action: 'mdi mdi-currency-usd',
        title: 'Financial',
        link: '/financial'
      },
      {
        action: 'mdi mdi-finance',
        title: 'Marketing',
        link: '/marketing'
      },
      {
        action: 'mdi mdi-brush',
        title: 'Design',
        link: '/design'
      },
      {
        action: 'mdi mdi-gavel',
        title: 'Legal',
        link: '/legal'
      },
      {
        action: 'mdi mdi-account-group',
        title: 'Members',
        link: '/members'
      },
      {
        action: 'mdi mdi-clipboard-check',
        title: 'Standards',
        link: '/standards'
      },
      {
        action: 'mdi mdi-wikipedia',
        title: 'Wiki',
        link: '/wiki'
      },
      {
        action: 'mdi mdi-information',
        title: 'Reference',
        link: '/reference'
      },
      {
        action: 'mdi mdi-beach',
        title: 'Sandbox',
        link: '/sandbox'
      }
    ]
  },

  methods: {
    addMenuItem(item) {
      MenuItemStore.data.items.push(item);
    }
  }
};

export default MenuItemStore;


// WEBPACK FOOTER //
// ./src/stores/MenuItemStore.js